<template>
  <div>
    Status servisa eRačuna: <v-chip class="ma-2" :color="color" text-color="white"> {{ serviceStatus }} </v-chip>
  </div>
</template>


<script>

import PondiService from '@/services/PondiService'

export default {
  name: '',
  props: [],
  data: ()=> ({
    serviceStatus: null,
    color: "green",
  }),
  async mounted () {
    try {
        const res = await PondiService.testping()
        const haveStatus = res && res.data ? res.data : null
        this.color = "red"
        this.serviceStatus = "Nije dostupan!"
        if (haveStatus && haveStatus.status && haveStatus.status.status === 'OK') {
          this.color = "green"
          this.serviceStatus = "OK."
        }
    } catch (error) {
      // eslint-disable-next-line
      console.log('greska kod monut dokumenta', error)
    }
  },
  methods: {

  },
  computed: {
  },
  watch: {

  },
  components: {

  }

}

</script>